import { get } from 'lodash';
import { NAME } from './modal-state-name';

const getModalState = (state) => state[NAME];

export const getModal = (state, id) => getModalState(state).openedModals[id];
export const getModalMeta = (state, id) => get(getModal(state, id), 'meta', {});
export const getOpenedModals = (state) => getModalState(state).openedModals;
export const getIsLoading = (state) => getModalState(state).isLoading;
